export const getTownAndCountry = async (lat, lon) => {
  try {
    const response = await fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`);
    const data = await response.json();
    const { town, city, country } = data.address;
    return { town: town || city, country };
  } catch (error) {
    console.error("Error fetching location:", error);
    return null;
  }
};